import * as React from "react";
import { atomFamily, useRecoilState } from "recoil";

import { PlannerCarouselPosition } from "@/types/plannerCarouselPosition";

const plannerResultState = atomFamily<{ entered: boolean; scrollTop: number; carousel: PlannerCarouselPosition }, number>({
  key: "plannerResultMotion",
  default: { entered: false, scrollTop: 0, carousel: { scrollLeft: 0 } },
});

/** 登録フロー内の再訪だけを記憶する。再起動時は既存の認証ガードがホームへ送る。 */
export function usePlannerResultMotion(userId: number, ready: boolean) {
  const [saved, setSaved] = useRecoilState(plannerResultState(userId));
  const initial = React.useRef(saved);
  React.useEffect(() => {
    if (!ready) return;
    setSaved((previous) => ({ ...previous, entered: true }));
    if (!initial.current.entered) return;
    const frame = window.requestAnimationFrame(() => window.scrollTo(0, initial.current.scrollTop));
    return () => window.cancelAnimationFrame(frame);
  }, [ready, setSaved]);
  const rememberScroll = (carousel: PlannerCarouselPosition) => setSaved({ entered: true, scrollTop: window.scrollY, carousel });
  return { animate: !initial.current.entered, initialCarouselPosition: initial.current.carousel, rememberScroll };
}
